// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","modal":"_32Wm1HJK82to","content":"y4h2AI3MFY7A","icon":"_3m3ciZLICIwg","button":"_26SK2JB_-qGx","no":"_175pb-egnS2W"};